export default __webpack_public_path__ + "867a36e020e4b2a87dacb81a817b80c7.png";